import { useState, useEffect } from 'react';
import { useInterval } from 'ahooks';
import dayjs from 'dayjs';
import useEvent from './useEvent';

const chinaDate = (timeString?: string) => {
    let time = !timeString ? new Date() : new Date(timeString);
    if (time.toString() === 'Invalid Date') {
        time = new Date();
    }
    const timezoneOffset = 8;
    const utc = time.getTime() + time.getTimezoneOffset() * 60000;
    const chinaDate = new Date(utc + timezoneOffset * 60 * 60 * 1000);
    return chinaDate;
};
const getCountDownDateTime = (targetTimeStampMs: number) => {
    const curTimeStamp = chinaDate().getTime();
    const ms = targetTimeStampMs - curTimeStamp;
    const leftTimeS = Math.floor(ms / 1000);
    if (ms <= 0) return [0, 0, 0, 0] as const;
    const d = Math.floor(leftTimeS / (24 * 60 * 60));
    const h = Math.floor((leftTimeS / (60 * 60)) % 24);
    const m = Math.floor((leftTimeS / 60) % 60);
    const s = Math.floor(leftTimeS % 60);
    return [d, h, m, s] as const;
};

const useTimeCountDown = () => {
    const [endTimeStampMs, setEndTimeStampMs] = useState<number>();
    const [countDownDateTime, setCountDownDateTime] =
        useState<ReturnType<typeof getCountDownDateTime>>();
    const getIsEnd = () =>
        countDownDateTime ? countDownDateTime?.every((n) => n === 0) : false;
    const clearInterval = useInterval(() => {
        const isEnd = getIsEnd();
        if (endTimeStampMs && !isEnd) {
            setCountDownDateTime(getCountDownDateTime(endTimeStampMs));
        }
    }, 1000);

    useEffect(() => {
        return clearInterval;
    }, [clearInterval]);

    /** 开始倒计时 */
    const startCountDown = useEvent((endTime: dayjs.ConfigType) => {
        const dateTime = dayjs(endTime).subtract(5, 'second');
        const ms = dateTime.valueOf();
        setEndTimeStampMs(ms);
    });

    return [
        startCountDown,
        countDownDateTime ?? [0, 0, 0, 0],
        getIsEnd()
    ] as const;
};

export default useTimeCountDown;
